module.exports = __webpack_public_path__ + "static/media/JangosIsland.d407a4e2.png";